import { connect } from 'react-redux';
import BatchTagDialog from './BatchTagDialog'
import { styles } from '../../containers/dockPadStyle'
import { compose } from 'redux';
import { withStyles } from '@material-ui/core';
import { lookaheadActions } from '../../actions/lookahead.actions';

import { 
    getConstraints, 
    getTradesSelectList, 
    getConstraintSelectList, 
    getTrades,
} from '../../selectors/phaseplan.selector'

import {
    getLookaheadTagSelectList,
    getLookaheadTagLocationsSelectList,
    getLookaheadTagId,
    getLookaheadTag,
    getLookaheadTrades,
    getLookaheadTradeSelectList,
    isNewLookaheadTag,
    getTagDate,
    getRow,
} from '../../selectors/lookahead.selector'

import { isBatchTagDialogOpen } from '../../selectors/dialog.selector'
import { getProjectId } from '../../selectors/project.selector';
import { alertActions } from '../../actions/alert.actions';
import { LookaheadTag } from '../../models/LookaheadTag';
import { ThunkDispatch } from 'redux-thunk';
import { dialogActions } from '../../actions/dialog.actions';
import { BatchData } from '../../models/BatchData';

const mapStateToProps = (state: any) => ({
    isBatchTagDialogOpen: isBatchTagDialogOpen(state),
    tradesSelectList: getLookaheadTradeSelectList(state),
    tagSelectList: getLookaheadTagSelectList(state),
    tagLocationsSelectList: getLookaheadTagLocationsSelectList(state),
    constraintSelectList: getConstraintSelectList(state),
    projectId: getProjectId(state),
    trades:  getLookaheadTrades(state),
    constraints: getConstraints(state),
    tagDate: getTagDate(state),
    row: getRow(state)

});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => ({
    closeTagDialogValue: () => dispatch(dialogActions.batchDialogClose()),
    submitBatchValue: (batchData:BatchData) => 
        dispatch(lookaheadActions.saveBatch(batchData)),
    errorAlert: (message: string) => dispatch(alertActions.error(message))
});


export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles, { withTheme: true })
)(BatchTagDialog)


// WEBPACK FOOTER //
// ./src/components/Dialogs/BatchTagDialogContainer.ts